module.exports = __webpack_public_path__ + "img/reimu.f04dce02.png";